import { useCallback, useState } from "react";
import { Apis } from "../../../lib/Apis";

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

export function useSeo() {
  const [loading, setLoading] = useState(false);

  const getModules = useCallback(async () => {
    const response = await Apis.getSeoModules();
    return response?.data?.data?.modules || [];
  }, []);

  const getEntities = useCallback(async (params) => {
    const response = await Apis.getSeoEntities(params);
    return response?.data?.data || { items: [], totalCount: 0 };
  }, []);

  const getSeoList = useCallback(async (params) => {
    setLoading(true);
    try {
      const response = await Apis.getSeoList(params);
      return response?.data?.data || { items: [], pagination: {} };
    } finally {
      setLoading(false);
    }
  }, []);

  const createSeo = useCallback(async (payload) => {
    try {
      const response = await Apis.createSeo(payload);
      if (response?.data?.success || response?.status === 201) {
        return response.data;
      }
      throw new Error(response?.data?.message || "Failed to create SEO");
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to create SEO"));
    }
  }, []);

  const updateSeo = useCallback(async (id, payload) => {
    try {
      const response = await Apis.updateSeo(id, payload);
      if (response?.data?.success || response?.status === 200) {
        return response.data;
      }
      throw new Error(response?.data?.message || "Failed to update SEO");
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to update SEO"));
    }
  }, []);

  const deleteSeo = useCallback(async (id) => {
    try {
      const response = await Apis.deleteSeo(id);
      if (response?.data?.success || response?.status === 200) {
        return response.data;
      }
      throw new Error(response?.data?.message || "Failed to delete SEO");
    } catch (error) {
      throw new Error(getErrorMessage(error, "Failed to delete SEO"));
    }
  }, []);

  return {
    loading,
    getModules,
    getEntities,
    getSeoList,
    createSeo,
    updateSeo,
    deleteSeo,
  };
}
